import { render, staticRenderFns } from "./ckEditor.vue?vue&type=template&id=3a83d66c&"
import script from "./ckEditor.vue?vue&type=script&lang=js&"
export * from "./ckEditor.vue?vue&type=script&lang=js&"
import style0 from "./ckEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports